module.exports = "/assets/faafe5d5d6ef3ab8bd19b08c659ef5af.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/PJ.png
// module id = 2842
// module chunks = 0